import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class IndeedIntegrationGuard {
    constructor(private router: Router) {}

    async canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
        // TODO Indeed, new integration
        //   This is a guard for https://localhost:4200/settings/integrations-v2/employers/select
        //   It's hardcoded to false to prevent users from going to the page until we're more far along
        //   Set to true while developing locally
        return false;
    }
}
